import { useDndContext } from "@dnd-kit/core";
import { useTranslation } from "@/packages/utils";

interface BoardEmptyColumnProps {
  visible: boolean;
}

export function BoardEmptyColumn({ visible }: BoardEmptyColumnProps) {
  const { active } = useDndContext();
  const { t } = useTranslation(["common"]);
  const show = visible && !!active;

  return (
    <div
      className="flex items-center justify-center min-h-[80px] rounded-xl border-2 border-dashed transition-opacity duration-150"
      style={{
        opacity: show ? 1 : 0,
        borderColor: show ? "#48484A" : "transparent",
        pointerEvents: show ? "auto" : "none",
      }}
    >
      <span className="text-[#6C6C70] text-sm">
        {t("common:board.dropHere")}
      </span>
    </div>
  );
}
